import { useTranslations } from 'next-intl'

import Button, { ButtonVariants } from '~/components/atoms/Button/Button'

import styles from './TeamListFilter.module.css'

export interface TeamListFilterProps {
  testID?: string
}

export default function TeamListFilter({ testID }: TeamListFilterProps) {
  const t = useTranslations('ourPeople')
  // const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)

  return (
    <div className={styles.base}>
      <Button
        variant={ButtonVariants.textLinkSmallUnderline}
        className={styles.button}
        scrollToId="the-team"
      >
        {t('theTeam')}
      </Button>
      <Button
        variant={ButtonVariants.textLinkSmallUnderline}
        className={styles.button}
        scrollToId="the-contributors"
      >
        {t('theContributors')}
      </Button>
    </div>
  )
}
